enum GtmCustomEventName {
  Download = 'sf.download',
}

export default GtmCustomEventName;
